import axios from "axios";
import { ordersServicesPath} from "../../../Constants";

const warehouseRestUrl = ordersServicesPath + '/organizations/warehouses'

export default class WarehouseService {

    static async getAll() {
        return axios.get(warehouseRestUrl);
    }

    static async update(data, id) {
        const {address: addressId, ...obj} = data
        return await axios.patch(warehouseRestUrl + '/' + id + "?addressId=" + addressId, JSON.stringify(obj), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(data) {
        const {address: addressId, ...obj} = data
        return await axios.post(warehouseRestUrl + "?addressId=" + addressId, JSON.stringify(obj), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(warehouseRestUrl + '/' + id);
    }
}